import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./ui";
import chartReducer from "./chart";
import routerReducer from "./router";
import modalReducer from "./modal";
import previewReducer from "./preview";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    chart: chartReducer,
    router: routerReducer,
    modal: modalReducer,
    preview: previewReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
